export const productionControl = {
	label: "Recetas y producción",
	at: "a las",
	attachedToModal: {
		title: "Vínculos del elemento",
		description: "Relación de registro con los cuales este elemento está vinculado",
		seeDetails: "Ver detalles",
	},
	tabs: {
		production: "Recetas y Producción",
		productionHistory: "Historial de Producción",
	},
	list: {
		emptyList: "Ninguna receta encontrada",
		createdAt: "Creado en {{date}}",
		title: "Recetas",
		subtitle: "Seleccione la receta que desea producir",
		searchPlaceholder: "Buscar por receta",
		links: "Vínculos",
		linksTotal: "{{count}} productos",
	},
	history: {
		table: {
			name: "Nombre",
			storage: "Inventario",
			fiscalCode: "SKU",
			createdAt: "Fecha de Creación",
			count: "Cantidad Producida",
			cost: "Valor",
			author: "Productor",
		},
		filters: {
			search: {
				label: "Buscar por",
				placeholder: "Nombre, productor o SKU",
			},
			interval: {
				label: "Filtrar por período",
			},
		},
	},
	producer: "Productor",
	expectedYield: "Rendimiento esperado",
	yield: "Rendimiento",
	storage: "Inventario",
	production: {
		title: "Producir insumo",
		steps: {
			CONFIGURATION: {
				title: "Configuración",
				description: "Seleccione el inventario para comenzar",
			},
			PREPARE: {
				title: "Preparación",
				description:
					"Llene la cantidad de cada ingrediente y haga clic en siguiente para continuar",
			},
			RESULT: {
				title: "Rendimiento",
				description: "Revise su producción y llene el rendimiento de su para finalizar",
			},
		},
		fields: {
			storage: {
				label: "Inventario",
				placeholder: "Seleccione un inventario",
			},
			producer: {
				label: "Productor",
			},
			inputCount: {
				label: "Cantidad utilizada",
			},
			inputLoss: {
				label: "Pérdida",
			},
			output: {
				label: "Cantidad producida",
			},
		},
		statusDialog: {
			loading: {
				dialogTitle: "Producción",
				title: "Produciendo...",
				subtitle: "Estamos produciendo su producto, aguarde un momento.",
			},
			success: {
				dialogTitle: "Producción - Éxito",
				title: "¡Producción concluida!",
				subtitle: "Entrada de {{count}} de {{recipe}} en el inventario {{storage}}",
			},
			error: {
				dialogTitle: "Producción - Error",
				title: "¡Ups, algo salió mal!",
				subtitle: "No pudimos realizar la producción. Intente nuevamente más tarde.",
			},
		},
		backToHome: "Volver a la página inicial",
		backToYield: "Volver al rendimiento",
		ingredientsTable: {
			name: "Ingrediente",
			count: "Cantidad",
			loss: "Pérdida",
			totalLoss: "Salida de Inventario",
		},
		outOfExpectedYield: {
			cancelText: "Editar rendimiento",
			description:
				"Su salida está muy fuera de la regla de producción, ¿quiere continuar de todos modos?",
		},
	},
	validation: {
		numberMustBeGreaterThanZero: "El valor debe ser mayor que 0",
		numberMustBePositive: "El valor debe ser positivo",
		nameMustHaveMaxCharacters: "El nombre debe tener máximo 30 caracteres",
		skuMustHaveMaxCharacters: "El SKU debe tener máximo 60 caracteres",
	},
	save: {
		newTitle: "Nueva regla",
		editTitle: "Editar regla",
		createAction: "Crear regla",
		addSupplyAction: "Agregar insumo",
		detailsTitle: "Detalles de la regla",
		productionRule: "Regla de producción",
		inputsTable: {
			name: "Insumo",
			count: "Cantidad",
			loss: "Pérdida",
			actions: "Acciones",
		},
		form: {
			name: {
				label: "Nombre",
				placeholder: "Ingrese el nombre",
			},
			yield: {
				label: "Rendimiento de la regla",
			},
			image: {
				label: "Foto",
				caption: "Imagen cuadrada o 500x500 píxeles",
			},
			inputName: {
				label: "Insumo o producto",
			},
			inputCount: {
				label: "Cantidad",
			},
			inputLoss: {
				label: "Pérdida",
			},
			output: {
				label: "Cantidad producida",
			},
		},
	},
	deleteDialog: {
		title: "Eliminar regla",
		content:
			"Al confirmar la acción usted elimina permanentemente esta regla de producción. ¿Desea continuar?",
	},
	recipe: {
		title: "Detalles de la receta",
		ingredientsTitle: "Receta y producción",
		totalCost: "Costo total",
		yield: "Rendimiento esperado",
		deleteInputDialog: {
			content:
				"Al confirmar la acción usted elimina el elemento de la receta. ¿Desea continuar?",
			title: "Eliminar Elemento",
		},
		multipleItems: "Elementos",
		singleItem: "Elemento",
		links: "Vínculos",
	},
	actions: {
		produce: "Producir",
		delete: "Eliminar",
		edit: "Editar",
	},
};
